module.exports = __webpack_public_path__ + "img/dialing.daf03e03.gif";